import React, { useState } from "react";
import { sendDemoEnquiry } from "../utils/email";

const DemoFormModal = ({ show, onClose }) => {
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [contact, setContact] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await sendDemoEnquiry({ name, company, contact, message });
      setSent(true);
      setTimeout(() => {
        setSent(false);
        setName("");
        setCompany("");
        setContact("");
        setMessage("");
        onClose();
      }, 2000);
    } catch (err) {
      setError("Failed to send. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="demo-modal-overlay">
      <div className="demo-modal">
        <button className="demo-modal-close" onClick={onClose}>&times;</button>
        <h2>Schedule Demo</h2>
        <form className="demo-form" onSubmit={handleSubmit}>
          <label>
            Name
            <input type="text" value={name} onChange={e => setName(e.target.value)} required />
          </label>
          <label>
            Company
            <input type="text" value={company} onChange={e => setCompany(e.target.value)} required />
          </label>
          <label>
            Contact Number
            <input type="tel" value={contact} onChange={e => setContact(e.target.value)} required />
          </label>
          <label>
            Message
            <textarea value={message} onChange={e => setMessage(e.target.value)} required />
          </label>
          <button type="submit" className="demo-send-btn" disabled={loading}>{loading ? "Sending..." : "Submit"}</button>
        </form>
        {sent && <div className="demo-sent-msg">Thank you! Your enquiry has been sent.</div>}
        {error && <div className="demo-sent-msg" style={{ color: 'red' }}>{error}</div>}
      </div>
    </div>
  );
};

export default DemoFormModal;
